import React, { useEffect, useState } from "react";
import { CSS } from "@dnd-kit/utilities";
import { useSortable } from "@dnd-kit/sortable";
import { motion } from "framer-motion";
import { useSelector } from "react-redux";
import { RxCross2 } from "react-icons/rx";

const SortableItem = ({
  ingredient,
  onEditChange,
  editMode,
  setEditMode,
  setIngredients,
  originalOrder,
  isSaving,
  handleRemoveIngredient
}) => {
  const { role } = useSelector((states) => states.auth);
  const [itemCode, setItemCode] = useState(ingredient.ing_item_code || "");
  const [selectedItem, setSelectedItem] = useState(null);
  const [itemSuggestions, setItemSuggestions] = useState([]);
  // const sortableProps = editMode
  //   ? useSortable({ id: ingredient.seq_no })
  //   : { attributes: {}, listeners: {}, setNodeRef: () => {} };

  const { attributes, listeners, setNodeRef, transform, isDragging } =
    useSortable({
      id: ingredient.seq_no,
      disabled: !editMode, // ✅ Disable sorting when editMode is false
    });

  const draggable =
    editMode
      ? {
        backgroundColor: isDragging ? "rgba(59, 130, 246, 1)" : "transparent",
        opacity: isDragging ? 1 : 0.9,
        boxShadow:  isDragging ? "0px 10px 20px rgba(0, 0, 0, 0.4)" : "0px 0px 0px rgba(0, 0, 0, 0)", // Adds shadow when dragging
        transform: isDragging ? CSS.Transform.toString(transform) : "none", // Moves the element with the drag
        transition: isDragging
        ? "transform 0.1s ease, box-shadow 0.15s ease"
        : "box-shadow 0.2s ease-out",
        zIndex: isDragging ? 1000 : "auto", // Smooth transition for shadow and movement
        position: isDragging ? "relative" : "static",
      }
      : {};

  const handleChangedComposition = (e) => {
    onEditChange(e, ingredient);
  };

  const fetchItemSuggestions = () => {
    if (!itemCode || itemCode.length < 1) return;
    if (itemCode.length >= 1) {
      // Fetch suggested item codes for the specific ingredient row
      fetch(`${process.env.REACT_APP_BASE_URI}/elixir/fetch_ingredient`, {
        method: "GET",
        headers: {
          Accept: "application/json",
        },
      })
        .then((response) => response.json())
        .then((data) => {
          const ingredientsList = data.data || [];
          console.log("list of ingredient data :", ingredientsList);

          const filteredSuggestions = ingredientsList
            .map((ingredient) => ({
              name: ingredient.ing_name,
              itemCode: ingredient.ing_item_code,
            }))
            .filter(
              (option) =>
                option.itemCode &&
                option.itemCode.toLowerCase().includes(itemCode.toLowerCase())
            );

            

          setItemSuggestions(filteredSuggestions);
        });
    }
  };

  const handleSelectItem = (item) => {
    
    setItemCode(item.itemCode);
    setSelectedItem(item); // Store selected item
    setItemSuggestions([]);

    // Auto-fill ingredient name and disable it
    onEditChange(
      { target: { name: "ing_item_code", value: item.itemCode } },
      ingredient
    );
    onEditChange(
      { target: { name: "ing_name", value: item.name } },
      ingredient
    );
  };

  function stripHtmlTags(html) {
    const temp = document.createElement("div");
    temp.innerHTML = html;
    return temp.textContent || temp.innerText || "";
  }

  useEffect(() => {
    if (!editMode && !isSaving) {
      setIngredients(originalOrder); // Restore previous state
      setItemCode(ingredient.ing_item_code);
    }
  }, [editMode, setIngredients, originalOrder]);

  useEffect(() => {
    if (typeof itemCode !== "string") return;

    const timer = setTimeout(() => {
      if (itemCode !== ingredient.ing_item_code && itemCode.length > 0) {
        fetchItemSuggestions();
      } else {
        setItemSuggestions([]);
      }
    }, 500);
    return () => clearTimeout(timer);
  }, [itemCode]);

  useEffect(() => {
    setItemCode(ingredient.ing_item_code || "");
  }, [ingredient.ing_item_code]);

  return (
    <motion.tr
      ref={setNodeRef}
      layout
      initial={{ opacity: 0 }}
      animate={{ opacity: 0.8 }}
      exit={{ opacity: 10 }}
      transition={{ duration: 0.3, ease: "easeInOut" }}
      className="  text-white"
      style={{
        ...draggable,
        cursor: editMode ? (isDragging ? "grabbing" : "grab") : "default",
        touchAction: "none"
      }}
    >
      <td className="px-4 py-2 text-white cursor-grab" {...listeners} {...attributes}>
        <div className="">
          <span className="text-xl">≡</span>
        </div>
      </td>
      {/* <td className="px-4 py-2">{ingredient.seq_no}</td> */}
      <td className="px-4 py-2">
        {(role === "admin" ) && editMode ? (
          <div className="relative inline-block">
            <input
              type="text"
              value={itemCode}
              onChange={(e) => setItemCode(e.target.value)}
              className="bg-gray-600 text-center text-white rounded px-3 py-2 border border-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 w-32"
            />
            {itemSuggestions.length > 0 && (
              <ul className="bg-gray-800 opacity-100 border border-gray-700 mt-1 max-h-24 overflow-y-auto absolute top-auto bottom-full w-36 z-10">
                {itemSuggestions.map((item, index) => (
                  <>
                  <li
                    key={index}
                    onClick={() => handleSelectItem(item)}
                    className="p-2 hover:bg-gray-700 cursor-pointer"
                    dangerouslySetInnerHTML={{
                      __html: `${item.itemCode} - ${item.name}`
                    }}
                  >
                  </li>
                  <hr />
                  </>
                ))}
              </ul>
            )}
          </div>
        ) : (
          <>{ingredient.ing_item_code}</>
        )}
        {/* {ingredient.ing_item_code} */}
      </td>
      <td className="px-4 py-2 text-white">
        {(role === "admin" ) && editMode ? (
          <>
            <input
              type="text"
              value={stripHtmlTags(ingredient.ing_name)}
              className="bg-gray-600 text-center text-gray-400 rounded px-3 py-2 border border-gray-400 focus:outline-none focus:ring-2 w-32"
              disabled
            />
          </>
        ) : (
          <> <span dangerouslySetInnerHTML={{__html: ingredient.ing_name}}></span></>
        )}
      </td>
      <td className="px-4 py-2 text-white">
        {(role === "admin" || role === "user") && editMode ? (
          <input
            type="number"
            name="per_composition"
            value={ingredient.per_composition}
            onChange={(e) => handleChangedComposition(e)}
            className="bg-gray-600 text-center text-white rounded px-3 py-2 border border-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 w-32"
          />
        ) : (
          <span>
            {ingredient.per_composition !== null &&
              ingredient.per_composition !== undefined &&
              ingredient.per_composition !== ""
              ? ingredient.per_composition
              : "N/A"}
          </span>
        )}
      </td>
      <td className="px-4 py-2">
        {(role === "admin" || role === "user") && editMode ? (
          <input
            type="text"
            name="alpha_composition"
            value={ingredient.alpha_composition}
            onChange={(e) => handleChangedComposition(e)}
            className="bg-gray-600 text-center text-white rounded px-3 py-2 border border-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 w-32"
          />
        ) : (
          <span className="text-white">
            {ingredient.alpha_composition !== null &&
              ingredient.alpha_composition !== undefined &&
              ingredient.alpha_composition !== ""
              ? ingredient.alpha_composition
              : "N/A"}
          </span>
        )}
      </td>
      <td>
        {(role === "admin" || role === "user") && editMode ? (
          <input
            type="checkbox"
            name="other_ing"
            checked={ingredient.other_ing}
            onChange={(e) => {
              handleChangedComposition(e);
            }}
            className="size-4"
          />
        ) : (
          <input
            type="checkbox"
            name="other_ing"
            checked={ingredient.other_ing}
            onChange={(e) => {
              handleChangedComposition(e);
            }}
            className="size-4"
            disabled
          />
        )}
      </td>
      <td>
        {
          (role === "admin") && editMode && (
            <button
              onClick={() => handleRemoveIngredient(ingredient.seq_no)}
              className="bg-red-500 hover:bg-red-600 text-white font-bold py-1 px-4 rounded"
            >
              <RxCross2 />
            </button>
          )
        }

      </td>
      {/* <td>
        {ingredient.updated_at}
      </td> */}
    </motion.tr>
  );
};

export default SortableItem;
